// extracted by mini-css-extract-plugin
export default {"care_main":"Care_care_main__VMqFZ","careCard":"Care_careCard__tgO1p"};